
import ContentLibrary from "@/components/content-library/ContentLibrary";

const ContentLibraryPage = () => {
  return <ContentLibrary />;
};

export default ContentLibraryPage;
